<template>
  <el-scrollbar wrap-class="scrollbar-wrapper">
    <el-menu
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      mode="vertical"
      :unique-opened="true"
    >
      <sidebar-item v-for="route in displayedRoutes" :key="route.path" :item="route" :base-path="route.path" />
    </el-menu>
  </el-scrollbar>
</template>

<script>
import { mapGetters } from 'vuex';
import SidebarItem from './SidebarItem';

export default {
  components: { SidebarItem },
  computed: {
    ...mapGetters(['permission_routers', 'sidebar']),
    displayedRoutes() {
      this.permission_routers.filter(
        pr =>
          pr.children &&
          (pr.children = pr.children.filter(c => c.children === undefined || (c.children && c.children.length)))
      );
      return this.permission_routers.filter(pr => pr.children && pr.children.length);
    },
    isCollapse() {
      return !this.sidebar.opened;
    }
  }
};
</script>
